// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","content":"qr-code_content__VR-f5","qr":"qr-code_qr__fQyHu","share":"qr-code_share__ydBC9","icons":"qr-code_icons__E6i2q"};